import React, { useState, useEffect } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { init } from "i18next";
import { useSelector } from "react-redux";

const StatusSelect = ({ onChange, form }) => {
    const statusesState = useSelector((state) => state.statusesReducer.data);
    const [status, setStatus] = useState("");

    useEffect(() => {
        if (statusesState.length === 0) {
            return;
        }
        const statusID =
            form.matchStatusId !== undefined && form.matchStatusId !== null
                ? form.matchStatusId
                : form.status;
        const exists = statusesState.some((s) => s.matchStatusId === statusID);

        setStatus(exists ? statusID : "");
    }, [statusesState]);

    const onChangeHandler = (event) => {
        const newStatusId = event.target.value;
        setStatus(newStatusId);
        onChange({
            status: newStatusId,
        });
    };

    return (
        <FormControl fullWidth>
            <InputLabel id="status-label">Status</InputLabel>
            <Select
                labelId="status-label"
                id="status-select"
                value={status}
                label="Status"
                onChange={onChangeHandler}
            >
                {statusesState.map((status, index) => {
                    return (
                        <MenuItem
                            key={status.matchStatusId}
                            value={status.matchStatusId}
                            disabled={index > 1}
                        >
                            {status.name}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};

export default React.memo(StatusSelect);
